// extracted by mini-css-extract-plugin
export default {"container-label":"ExecutiveReport_container-label__g66E6","container-description":"ExecutiveReport_container-description__CFELc"};